module.exports = ".pi-external-link:hover {\n  cursor: pointer;\n}\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/orders/indi-order/indi-order.component.css
// module id = ./src/app/orders/indi-order/indi-order.component.css
// module chunks = main